import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <Link to="/" className="logo">
          <div className="logo-cube"></div>
          <span>Blender Portfolio</span>
        </Link>

        <div className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/#gallery" onClick={() => setMenuOpen(false)}>Gallery</Link>
          <Link to="/#about" onClick={() => setMenuOpen(false)}>About</Link>
          <a href="#commission" className="commission-btn" onClick={() => {
            setMenuOpen(false);
            document.querySelector('#commission-section').scrollIntoView({ behavior: 'smooth' });
          }}>
            Request Commission
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;